/**
 * Foundations, at `/foundations`: seven small checked tasks, then a choice of
 * discipline (docs/foundations.md). The page itself is the shared track page
 * (components/tracks/TrackPage.tsx); the steps are ./steps.tsx.
 */
import { useStrings } from '../../state/useLocale';
import { TrackPage } from '../tracks/TrackPage';
import { STEPS } from './steps';
import { Disciplines } from './Disciplines';

export function Foundations() {
  const s = useStrings().foundations;
  return (
    <TrackPage track="foundations" text={s} steps={STEPS}>
      <Disciplines />
    </TrackPage>
  );
}
